/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

export default new Map([
  [`add-shield-user`, `Ensuring X-Pack security superuser exists in Elasticsearch`],
  [`add-voting-exclusion`, `Adding master voting exclusions for nodes being stopped`],
  [`allocate-instances`, `Allocating deployment instances`],
  [`apply-cluster-license`, `Applying X-Pack license to deployment`],
  [`apply-curation-settings`, `Applying index curation settings`],
  [`apply-monitoring-config`, `Applying X-Pack monitoring configuration`],
  [`apply-elasticsearch-system-cluster-assets`, `Applying Elasticsearch system cluster assets`],
  [`apply-kibana-system-cluster-assets`, `Applying Kibana system cluster assets`],
  [`apply-transient-cluster-settings`, `Applying transient cluster settings`],
  [`autoscaling-decision`, `Autoscaling decision information`],
  [`calculate-incremental-apm-change`, `Determining incremental changes to APM cluster`],
  [`calculate-incremental-docker-change`, `Determining incremental changes to Docker cluster`],
  [
    `calculate-incremental-elasticsearch-change`,
    `Determining incremental changes to Elasticsearch cluster`,
  ],
  [`calculate-incremental-kibana-change`, `Determining incremental changes to Kibana cluster`],
  [`check-enterprise-license`, `Checking enterprise license`],
  [`check-upgrade-rules`, `Verifying deployment can be upgraded`],
  [`clean-up`, `Performing clean-up`],
  [`cleanup`, `Performing clean-up`],
  [`close-indices`, `Closing indices`],
  [`configure-auto-expand-indexes`, `Adjusting auto-expand indexes in Elasticsearch`],
  [`configure-autoscaling-policy`, `Configuring autoscaling policy in Elasticsearch`],
  [`create-apm-instances`, `Creating APM instances`],
  [`create-elasticsearch-instances`, `Creating Elasticsearch instances`],
  [`create-kibana-instances`, `Creating Kibana instances`],
  [`create-es-users`, `Creating Elasticsearch users`],
  [`deallocate-instances`, `Deallocating deployment instances`],
  [`delete-instances`, `Deleting deployment instances`],
  [`ensure-app-auth-tokens`, `Ensuring application auth tokens exist`],
  [`ensure-instances-ready`, `Starting non-running instances and turning off maintenance mode`],
  [`ensure-repository`, `Ensuring snapshot repository exists`],
  [`ensure-s3-resources`, `Preparing to store snapshots`],
  [`ensure-shield-system-key`, `Ensuring X-Pack security system key is present`],
  [`ensure-clean-allocations`, `Ensuring valid shard allocation rules are present`],
  [`error`, `Plan failed`],
  [`finished-rotating`, `Finished rotating`],
  [`forced-cluster-reboot`, `Force restarting deployment`],
  [`generate-node-certificates`, `Generating node certificates`],
  [`get-snapshot-settings`, `Pulling down snapshot settings`],
  [`migrate-data`, `Migrating shard data`],
  [`migrate-from-shield-to-x-pack-security`, `Migrating from Shield security to X-Pack security`],
  [`migrating-elasticsearch-version`, `Migrating Elasticsearch version`],
  [`migrating-kibana6-version`, `Migrating Kibana version`],
  [`update-cluster-settings`, `Updating cluster settings`],
  [`update-ml-settings`, `Updating cluster ML settings`],
  [`override-instance-data`, `Applying node type overrides to instance data`],
  [`perform-snapshot`, `Taking snapshot`],
  [`plan-completed`, `Plan successful`],
  [`plan-validator`, `Validating configuration changes`],
  [
    `pre-instance-removal-safety-checks`,
    `Making sure it is safe to remove instances from the cluster`,
  ],
  [`post-plan-cleanup`, `Post plan cleanup`],
  [
    `prepare-migration-from-shield-to-x-pack-security`,
    `Preparing Migration from Shield security to X-Pack security`,
  ],
  [`remove-voting-exclusion`, `Cleaning up voting exclusions`],
  [`removing-maintenance-mode`, `Removing maintenance mode`],
  [`resize-instances`, `Resizing instances`],
  [
    `resolve-current-instance-state`,
    `Fetching information about current state of deployment instance`,
  ],
  [`resolve-instances-acls`, `Resolving node access control lists`],
  [`resolve-node-type`, `Resolving node type`],
  [`restart-es6-watcher`, `Restarting Elasticsearch Watcher service`],
  [`restore-snapshot`, `Restoring snapshot`],
  [`rollback`, `Rolling back changes`],
  [`rollback-clean-up`, `Cleaning up after rollback`],
  [`rolling-upgrade`, `Performing a rolling change`],
  [`rotating`, `Performing rolling restart`],
  [`run-index-curation`, `Running index curation`],
  [`seed-instances`, `Seeding Elasticsearch instances with discovery hosts`],
  [`update-initial-master-nodes`, `Updating the initial master nodes`],
  [`set-maintenance`, `Setting maintenance mode`],
  [`set-quorum-size`, `Setting Elasticsearch cluster quorum size`],
  [`setting-maintenance-mode`, `Setting maintenance mode`],
  [`shutdown-elasticsearch-nodes`, `Calling Elasticsearch node shutdown API`],
  [`start-instances`, `Starting instances`],
  [`stop-ilm`, `Stopping Index Lifecycle Management`],
  [`step-cleanup`, `Cleaning up after step cleanup`],
  [`step-failed`, `Step failed`],
  [`step-rollback`, `Rolling back changes made by step rollback`],
  [`stop-instances`, `Stopping instances`],
  [`success`, `Plan successful`],
  [`suspend-peristent-tasks`, `Suspending persistent tasks`],
  [`suspend-snapshotting`, `Disabling snapshots`],
  [`synced-flush`, `Performing synced flush`],
  [`update-connected-clusters`, `Updating remote clusters`],
  [`update-remote-clusters`, `Updating remote clusters`],
  [`validate-elasticsearch-plugin-versions`, `Validating Elasticsearch plugin versions`],
  [`validate-enough-disk-space`, `Validating disk space`],
  [
    `validate-installed-elasticsearch-plugins`,
    `Validating Elasticsearch plugins were installed correctly`,
  ],
  [`validate-plan-prerequisites`, `Validating plan prerequisites`],
  [`validate-plan-safety`, `Validating plan safety`],
  [`verify-non-split`, `Verifying deployment is not in split-brain state`],
  [`wait-elasticsearch-version`, `Waiting on Elasticsearch to upgrade`],
  [`wait-kibana-version`, `Waiting on Kibana to upgrade`],
  [`wait-for-index-curation-lock`, `Waiting for index curation lock`],
  [`wait-for-pending-snapshot`, `Waiting for any pending snapshots to complete`],
  [`wait-for-snapshotting-lock`, `Waiting for snapshotting lock`],
  [`wait-until-deallocated`, `Waiting until instances are deallocated`],
  [`wait-until-masters-elected`, `Waiting until master instances are elected`],
  [`waiting-until-masters-elected`, `Waiting until master instances are elected`],
  [`wait-until-running`, `Waiting until instances are running`],
  [`wait-until-shards`, `Waiting until all shards and replicas are available`],
  [`wait-until-shards-available`, `Waiting until shards are available`],
  [`wait-until-shards-initialized`, `Waiting until shards are initialized`],
  [`wait-until-snapshot-restored`, `Waiting until snapshots are restored`],
  [`waiting-until-started`, `Waiting until instances are started`],
  [`wait-until-stopped`, `Waiting until instances are terminated`],
  [`wait-until-stopped-ignore-allocator-status`, `Waiting until instances are terminated`],
  [`waiting-until-stopped`, `Waiting until instances are terminated`],
])
